import React from 'react';
import { Link } from 'react-router-dom';
import { startCase, camelCase } from 'lodash';
import ActionsMenu from 'components/ActionsMenu';
import { EQUIPMENT_LANDING_MENU } from 'utilities/menus';
import { paths } from 'routes/paths';

export type EquipmentRow = {
  id: string;
  name?: string;
  type?: string;
  currentStatus?: string;
  year?: number | string;
  make?: string;
  model?: string;
};

export type EquipmentAction = (action: string, equipment: EquipmentRow) => void;

type EquipmentTableCellProps = {
  field: string;
  equipment: EquipmentRow;
  onAction: EquipmentAction;
};

const asTitle = (value?: string) => startCase(camelCase(value ?? ''));

const cellRenderers: Record<
  string,
  (equipment: EquipmentRow, onAction: EquipmentAction) => React.ReactNode
> = {
  name: equipment => (
    <Link className="font-bold" to={`${paths.equipment}/${equipment.id}/view`}>
      {equipment.name}
    </Link>
  ),
  type: equipment => asTitle(equipment.type),
  currentStatus: equipment => asTitle(equipment.currentStatus),
  year: equipment => equipment.year,
  make: equipment => equipment.make,
  model: equipment => equipment.model,
  '': (equipment, onAction) => (
    <div
      data-testid="equipment-table-options-menu"
      className="absolute right-0 top-1/2 -translate-y-1/2 mr-2"
    >
      <ActionsMenu
        portal
        onAction={(action: string) => onAction(action, equipment)}
        options={EQUIPMENT_LANDING_MENU}
      />
    </div>
  )
};

const EquipmentTableCell = ({
  field,
  equipment,
  onAction
}: EquipmentTableCellProps) => (
  <>{cellRenderers[field]?.(equipment, onAction) ?? null}</>
);

export default EquipmentTableCell;
